import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type TPopupProps = {
  title: string;
  desc: string;
  actionText?: { submit?: string; cancel?: string };
  onSubmit?: string;
};

const initialState = {
  showPopup: false,
  title: '',
  desc: '',
  actionText: { submit: 'Ok', cancel: 'Cancel' },
  onSubmit: '',
};

export const popupSlice = createSlice({
  name: 'popupSlice',
  initialState,
  reducers: {
    showPopup: (
      state,
      action: PayloadAction<TPopupProps>
    ) => {
      if (state.showPopup) {
        return state;
      } else {
        const payload = action.payload;
        return {
          ...state,
          ...payload,
          showPopup: true,
          actionText: {
            ...state.actionText,
            ...payload.actionText,
          },
        };
      }
    },
    removePopup: () => initialState,
  },
});

export const { showPopup, removePopup } =
  popupSlice.actions;

export default popupSlice.reducer;
